<template>
  <draggable class="fts-list-designer-layouter" 
    :class="{'list-designer-layouter-wrap': wrap}" 
    v-model="list.columns" 
    v-bind="dragOptions" 
    handle=".handle">
    <div class="list-designer-column" v-for="column in list.columns" :key="column.id">
      <fts-list-designer-element 
        :item="column" 
        :wrap="wrap" 
        :removeable="removeable" 
        @update="update"
        @remove="remove"
      />
    </div>
  </draggable>
</template>

<script>
import commons from "../commons/commons";
import draggable from "vuedraggable";

import FTSListDesignerElement from "./FTSListDesignerElement";

export default {
  props: {
    list: {
      type: Object,
      default: () => ({
        columns: []
      })
    },
    columns: {
      type: Array
    },
    wrap: {
      type: Boolean,
      default: true,
    },
    removeable: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    draggable,
    "fts-list-designer-element": FTSListDesignerElement,
  },
  data: () => ({
    dragOptions: commons.dragOptions,
  }),
  methods: {
    update(data) {
      const column = this.list.columns.find(x => x.id === data.id);
      this.$set(this.list.columns, this.list.columns.indexOf(column), data);
      this.$emit("input", data);
    },
    remove(data) {
      this.list.columns.splice(this.list.columns.indexOf(data), 1);
      this.$emit("input", data);
    }
  }
}
</script>

<style lang="scss">
.fts-list-designer-layouter {
  display: flex;
  align-items: flex-start;
  &.list-designer-layouter-wrap {
    flex-wrap: wrap;
  }
  &:not(.list-designer-layouter-wrap) {
    max-width: 100%;
    .list-designer-element-name {
      white-space: nowrap;
    }
  }
  .list-designer-column {
    margin: 0.375rem 0;
  }
}

</style>